import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    marginRight: 0,
  },
  inputPlaceholder: {
    position: "absolute",
    left: 30,
  },
  filter: {
    width: "200px",
  },
  filterDropdownListContainer: {
    height: 300,
    padding: 5,
    margin: -5,
    overflowX: "hidden",
    overflowY: "auto",
  },
  add: {
    marginLeft: 10,
  },
}));

export default useStyles;
